(function () {
    'use strict';

    angular
        .module('admin')
        .controller('UserFormController', UserFormController);

    UserFormController.$inject = ['$state', '$stateParams', 'UserService','RoleService','PermissionService','AreaService', '$timeout','Areas'];

    function UserFormController($state, $stateParams, UserService, RoleService, PermissionService, AreaService, $timeout, Areas) {
        var vm = this;
            vm.name                 = '';
            vm.email                = '';
            vm.password             = '';
            vm.function             = '';
            vm.shortDescription     = '';
            vm.socialSkype          = '';
            vm.socialFacebook       = '';
            vm.socialTwitter        = '';
            vm.socialLinkedin       = '';
            vm.socialGooglePlus     = '';
            vm.phone                = '';
            vm.permissions          = new Array();
            vm.areas                = Areas;
            vm.permissionsRevoke    = new Array();
            vm.select               = [];
            vm.permissionsSelected  = [];
            vm.submit               = submit;
            //vm.allAreas             = allAreas;
            vm.selected             = selected;
            vm.checkPermissions     = checkPermissions;
            vm.unSelected           = unSelected;
            vm.selectRoles          = selectRoles;
            vm.permissionsList      = permissionsList;
            vm.permissionsByRole    = permissionsByRole;
            vm.getPermissions       = getPermissions;
            vm.edit                 = edit;


        function activate() {
            vm.selectRoles();
            if ($stateParams.hasOwnProperty('id')) {
                vm.edit($stateParams.id);
            }
            //vm.permissionsList();
        }

        function selectRoles () {
            RoleService.getUserRoles().then(function(response){
                vm.roles = response.data;
            }).catch(function(err) {

            });
        }

        function checkPermissions (role, isChecking) {
                role.permissions.forEach(function (rolePermission) {
                    vm.areas.forEach(function(area) {
                        area.modules.forEach(function(module){
                            module.permissions.forEach( function (permission) {
                                if(permission.id == rolePermission.id)
                                    permission.checked = isChecking;

                            })
                        });
                    });
                });
        }


        // function allAreas () {
        //     return AreaService.getAll();
        // }

        function permissionsList () {
            RoleService.getPermissions().then(function(response){
               // vm.permissions = response.data;
            }).catch(function(err) {

            });
        }

        function permissionsByRole (id, remove) {

            RoleService.getRolePermissions(id).then(function(response){
                if(parseInt(response.data.length)>0) {
                    if(remove === false){
                        angular.forEach(response.data, function (element) {
                            vm.permissions.push(element);
                        });
                    } else {
                        angular.forEach(response.data, function (element) {
                            vm.permissions.pop(element);
                        });

                        angular.forEach(response.data, function (element) {
                            vm.permissionsRevoke.pop(element);
                        });
                    }
            }

            }).catch(function(err) {
                // deu erro
            });
        }
        
        function selected (role) {
            vm.checkPermissions(role, true);
        }

        function unSelected (role) {
            vm.checkPermissions(role, false);
        }

        function getPermissions() {
                vm.permissionsSelected = [];
                vm.areas.map(function (area) {
                    area.modules.map(function (module) {
                        module.permissions.map(function (permission) {
                            if (permission.checked === true)
                                vm.permissionsSelected.push(permission.id);
                            return vm.permissionsSelected;
                        })
                    });
                });
        }

        function submit () {
            vm.getPermissions();
            vm.fields = {
                name                : vm.name,
                email               : vm.email,
                password            : vm.password,
                function            : vm.function,
                shortDescription    : vm.shortDescription,
                socialSkype         : vm.socialSkype,
                socialFacebook      : vm.socialFacebook,
                socialTwitter       : vm.socialTwitter,
                socialLinkedin      : vm.socialLinkedin,
                socialGooglePlus    : vm.socialGooglePlus,
                phone               : vm.phone,
                permissions         : vm.permissionsSelected,
                roles               : vm.select
            };

            if ($stateParams.hasOwnProperty('id')) {
                UserService.update($stateParams.id, vm.fields);
            } else {
                UserService.save(vm.fields);
            }
            $state.go('root.admin.list');
        }

        function edit (id) {
             UserService.get(id).then(function (response) {
                    vm.name                = response.data.name;
                    vm.email               = response.data.email;
                    vm.password            = response.data.password;
                    vm.function            = response.data.function;
                    vm.shortDescription    = response.data.shortDescription;
                    vm.socialSkype         = response.data.socialSkype;
                    vm.socialFacebook      = response.data.socialFacebook;
                    vm.socialTwitter       = response.data.socialTwitter;
                    vm.socialLinkedin      = response.data.socialLinkedin;
                    vm.socialGooglePlus    = response.data.socialGooglePlus;
                    vm.phone               = response.data.phone;
                    vm.select              = response.data.roles;
                    return response.data;
             }).then(function(data) {
                 vm.checkPermissions(data, true);
             }).catch(function(err){
                 console.log(err);
             });
        }
        activate();
    }

})();